import { getRoute } from './getRoute';
import { type Route, type RouteParams } from './types';

type GetEndRoute = {
  (path: string): Route;
  <Params extends RouteParams>(path: string): Route<Params>;
};

export const endRoute: GetEndRoute = (path: string) => getRoute(path, { exact: true });
